var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWaveSyncDeactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_25291_14525)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_25291_14525",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_25291_14525",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_25291_14525",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAET0lEQVRoge2YTUgjZxjHHzMzGlT8SDRDQyxtEgVxjc1BbVgPBvXQUtCRZJvWi4sLHhTWUroH+3XZS6l7DF7Wgyd3keCOAfHjIB7CBho/CHiaJKZMIIiiZnQGYkzSSyPhzUwSWeJE8AdzyPO8A/8/ed7nfd6pSKfT8JBRyC3gU3k0IDePBuSm7Aw4nU7m+Pi4qdj1ZWfA7/cb5+fn2f39/ZFi1pedAQCAaDSqXFhYWKFp+m2htWVpAAAgkUjA2traRKGSKlsDGfx+v9HpdEakSqoi3ygRDAa/8vl8f7Is+/Tk5ETFcRyWSqVKpTUvBEHA0NDQwvDw8IvsuKgBlmUN6+vrK3t7e51yCZbCZDIFbTbbU5IkjwFEDHg8nkmapp2xWAyTRWERtLe3R2dmZrQAAHh2Ymdn5+fl5eW5RCIhj7Ii6OzsPLLb7ZbM71sDfr//W5fL9Xe5ipfaAzgAQCwWw2mafh+PxyvQF6uqqtJms9nb0dExbzAYVtRq9VUphU5OTuZsSpIkrymK+t5sNn9AczgAgMfjmYtEIrVoUqfT8Q6Hw9ra2vpPSdQWAbppUXAAgIODg+doorm5OTExMdGu1WrZUosUQ6pkUPCjo6MnLMvWoYnBwcHf5RJPkmScoiiHWMmg4AzD/Ij2eo1Gc93f3/9XqQTmw2QyBWw2m4UkyVM0x3Fci9frncMwLN7d3f1rXV0di5+dnT1BF2q12qP7kZvL1NRUq1ic47iWxcXF4OXlJQEAcHh4+MPY2FiHIpVKVaKLlUrleamF3hWv1/smIx4A4OrqCt/d3X1d9sNchpubm5x9KghCy4MxIIWCIAgODdbW1srSffKRTCar0BiGYXGFxWL5Ra1W384PKpXqpqen57f7lVcYQRA+Q2MEQXC4Tqf7d3p62uDxeN7gOB7v7e2dFev/giA0ra6ufnQ4HKJdotScnp5+icbq6+sPcQAArVbL2u32Z1IvBwKB4a2trXfn5+fKUoqUwufzvYrFYjnd0mAwLOFiL2Szvb391ufzTcg1pf5/eL1G4xqN5lKj0fglDWRKJhQKGUsrUZpoNNrtdru3OY4j0FxbW9siAHKhyRAIBEY2NzffXVxc5Oz8UiMIgiYcDn/DMMwkwzBfX19f54z4arWa7+vr+wlA5Eopd8kUorKyMj06OvqdXq9fA8j6B3ieJ91utycUChnkk5cfHMfBarW+yogHyDLgcrn2I5FITq8tF6qrq5NWq/VlV1eXMzt+W0I8z5M0TXvD4fAXcgiUAsMw0Ov1hwMDA5RKpWLQfNntAYVCAUqlMtnY2HhOkuRHs9n8B0mSB1LrRT9sBQKBkY2Njfdih8fs7GxOV5AT0WnUaDR+GB8f/1yv1wfvW9BdkRyna2pqjh0Oh9FisSwQRM45UjYUvA9YrdYXFEVRDQ0N8fsQdGfS6XRRD8/zTUtLS0yx6+/ryft5/SHw8K+Ucgv4VB4NyM2DN/Afm29Jo/vER4EAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaveSyncDeactive);
export default __webpack_public_path__ + "static/media/icon-wave-sync-deactive.66b125983ff85dc786de0b518ef022e9.svg";
export { ForwardRef as ReactComponent };